/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geowindow901Inputs */

const en_geowindow901 = /** @type {(inputs: Geowindow901Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 days`)
};

const de_geowindow901 = /** @type {(inputs: Geowindow901Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 Tage`)
};

/**
* | output |
* | --- |
* | "90 days" |
*
* @param {Geowindow901Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geowindow901 = /** @type {((inputs?: Geowindow901Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geowindow901Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geowindow901(inputs)
	return de_geowindow901(inputs)
});
export { geowindow901 as "geoWindow90" }